import { CloseOutlined } from "@mui/icons-material";
import {
  alpha,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import availableCourses from "./availableCourses";
import "./coursesStyle.css";
import LessonsOfCourse from "./LessonsOfCourse";

const LandingPageCousresAvailableSection = () => {
  const [isReadMoreOpen, setOpenReadMore] = useState();
  const handleOpenReadMoreAboutCourse = (courseToShow) =>
    setOpenReadMore(courseToShow);
  const handleCloseReadMoreAboutCourse = () => setOpenReadMore(false);
  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 3,
        }}
      >
        {availableCourses.map((course, index) => (
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Box id="card-some_id" class="card">
              <div class="card-image">
                <img src={course.img} alt="card" loading="eager" />
              </div>

              <div class="card-info">
                <div class="content">
                  <div class="author-image"></div>

                  <div class="something">
                    <h2 class="card-title">
                      <a href="#">{course.name}</a>
                    </h2>
                    <span class="card-category">{course.secondary}</span>
                  </div>

                  <div class="card-coin-icon"></div>
                </div>

                <div class="prices">
                  <div class="price">
                    <strong>{`مساق ${index + 1}`}</strong>
                  </div>

                  <div class="price">
                    <strong>{`${course.lessons.length} دُروس`}</strong>
                  </div>

                  <div class="price">
                    <Chip
                      label={course.label}
                      variant="filled"
                      color={index === 0 ? "info" : "warning"}
                    />
                  </div>
                </div>
              </div>

              <div class="card-actions">
                <a
                  onClick={() => handleOpenReadMoreAboutCourse(course)}
                  className="btn btn-base btn-g-blue-veronica text-base"
                >
                  إقرأ المزيد
                </a>
              </div>
            </Box>
          </Grid>
        ))}
      </Grid>
      {Boolean(isReadMoreOpen) && (
        <Dialog
          open={Boolean(isReadMoreOpen)}
          onClose={handleCloseReadMoreAboutCourse}
          fullWidth
          componentsProps={{
            backdrop: {
              sx: {
                background: "#00205b1c",
                backdropFilter: "blur(3px)",
                WebkitBackdropFilter: "blur(3px)",
                transition: "all 0.25s linear",
              },
            },
          }}
          sx={{
            transition: "all 0.25s linear",
          }}
          maxWidth="md"
          id="read-more-dialog"
          PaperProps={{
            sx: {
              backgroundColor: (theme) => alpha("#0b0b0f", 0.98),
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box />
            <Typography
              sx={{
                color: (theme) => theme.palette.getContrastText("#0b0b0f"),
              }}
              variant="h2"
            >
              {isReadMoreOpen.name}
            </Typography>
            <IconButton
              sx={{
                color: (theme) => theme.palette.getContrastText("#0b0b0f"),
              }}
              onClick={handleCloseReadMoreAboutCourse}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <LessonsOfCourse course={isReadMoreOpen} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default LandingPageCousresAvailableSection;
